import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

class ImageUpload extends Component {
    state = { error: false };

    _onChange = event => this.props.onChange(event.target.result, this.props.name);
    _imageDropped = files => {
        this.setState({ error: false });
        if (files[0]) {
            const image = files[0];
            const reader = new FileReader();
            reader.onload = this._onChange;
            reader.readAsDataURL(image);
        } else {
            this.setState({ error: true });
            this.props.onChange('', this.props.name);
        }
    };
    render() {
        return (
            <div
                className={`ckp-image-upload ${this.props.className} ${this.state.error ? 'is-error' : ''} ${
                    this.props.value && this.props.keepLabel ? 'is-labeled' : ''
                } ${this.props.disabled ? 'is-disabled' : ''}`}
            >
                {this.props.value && this.props.keepLabel ? (
                    <p className="ckp-image-upload-label-keep">{this.props.label}</p>
                ) : null}
                <p className="ckp-image-upload-label">{this.props.label || 'Add picture'}</p>
                {this.state.error ? <p className="ckp-image-upload-error">Size is restricted to 1MB.</p> : ''}
                {this.props.disabled ? null : (
                    <Dropzone
                        maxSize={1000000}
                        className="ckp-image-upload-dropzone"
                        accept="image/*"
                        onDrop={this._imageDropped}
                        multiple={false}
                    />
                )}
                {this.props.value && (
                    <img className={`ckp-image-upload-preview`} alt="Upload preview" src={`${this.props.value}`} />
                )}
            </div>
        );
    }
}

ImageUpload.defaultProps = {
    className: ''
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/forms/ImageUpload.js